/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Type_Central_Air_Handling_UnitInputs */



/**
* | output |
* | --- |
* | "AHU" |
*
* @param {Heating_Network_Type_Central_Air_Handling_UnitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_type_central_air_handling_unit = /** @type {((inputs?: Heating_Network_Type_Central_Air_Handling_UnitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Network_Type_Central_Air_Handling_UnitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("AHU")
	return /** @type {LocalizedString} */ ("CTA")
});